export const CardSkeleton = ({ className = "" }) => {
  return (
    <div className={`${className} h-fit`}>
      <h4 className="content-skeleton mb-0">{""}</h4>
      <div className="card-title-container w-100">
        <div className="d-flex justify-content-between w-100">
          <h4 className="content-skeleton m-0">{""}</h4>
          <h4 className="content-skeleton m-0">{""}</h4>
        </div>
        <div className="card-detail-container w-100 d-flex flex-column gap-2">
          <h4 className="content-skeleton m-0 w-50">{""}</h4>
          <h4 className="content-skeleton m-0">{""}</h4>
          <h4 className="content-skeleton m-0">{""}</h4>
        </div>
        <div className="d-flex justify-content-between w-100">
          <h4 className="content-skeleton w-20 m-0">{""}</h4>
          <h4 className="content-skeleton w-20 m-0">{""}</h4>
        </div>
      </div>
    </div>
  );
};
